import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'datex',
  standalone: false,
})
export class DatexPipe implements PipeTransform {
  transform(value: string, format: string = ''): string {
    if (!value || value === '') {
      return '';
    }
    return moment(value.toString().replace(/[\ ]\+([0-9]|:)*/, '')).format(
      format
    );
  }
}
